import React, { PropsWithChildren } from 'react';

export const SubtitleText: React.FC<PropsWithChildren> = ({ children }) => {
	return (
		<h3 className="text-zinc-500 font-lora font-semibold leading-3 text-xs sm:text-base p-[2px]">{children}</h3>
	);
};
